import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {Response, StaticMethods} from '../../../model/GeneralModels';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {IntroductionLetterService} from '../../../services/introduction-letter.service';
import {MatDialog} from '@angular/material/dialog';

@Component({
  selector: 'app-basic-information',
  templateUrl: './basic-information.component.html',
  styleUrls: [
    '../../../assets/vendor/mdi-font/css/material-design-iconic-font.min.css',
    '../../../assets/Content/src/css/lib.vendor.css',
    '../../../assets/Content/src/css/lib.picker.css',
    '../../../assets/vendor/font-awesome-4.7/css/font-awesome.min.css',
    '../../../assets/css/light.theme.css'
  ]
})
export class BasicInformationComponent implements OnInit {
  basicInformationForm: FormGroup = this.fb.group({
    insuranceNumber: ['', Validators.required]
  });
  private productName: string;

  constructor(private introductionLetterService: IntroductionLetterService,
              private activatedRoute: ActivatedRoute,
              private router: Router, private dialog: MatDialog, private fb: FormBuilder) {
  }

  ngOnInit() {
    this.activatedRoute.params.subscribe((params: Params) => {
      this.productName = params.productName;
    });
  }

  goNext() {
    console.log(this.basicInformationForm.valid);
    if (this.basicInformationForm.controls.insuranceNumber.value) {
      this.introductionLetterService.getInsuranceInfo(this.basicInformationForm.controls.insuranceNumber.value)
        .subscribe((response: Response) => {
          console.log(response);
          if (response.success) {
            console.log('data: ', response.data);
            if (response.data.innerRequest) {
              this.router.navigate([`/insurance-service/${this.productName}/details`], {
                state: {
                  requestID: response.data.ILRequestID
                }
              });
            } else {
              if (!response.data.request) {
                // tslint:disable-next-line:max-line-length
                StaticMethods.openDialog(this.dialog, 'بیمه نامه با این شماره موجود نیست در صورتیکه این بیمه نامه را از هشتگ بیمه خریداری نکرده اید  تایید و در صورتی که شماره بیمه نامه را اشتباه وارد کرده اید لغو را کلیک کنید',
                  (result) => {
                    if (result) {
                      this.router.navigate([`/insurance-service/${this.productName}/create`], {
                        state: {
                          insuranceNumber: this.basicInformationForm.controls.insuranceNumber.value
                        }
                      });
                    }
                  }, '350px');
              } else {
                if (response.data.request.multipleSubRequests || !response.data.request.subsetList.length) {
                  this.router.navigate([`/insurance-service/${this.productName}/new-request`],
                    {
                      state: {
                        insurance: response.data.request,
                      }
                    });
                } else {
                  this.router.navigate([`/insurance-service/${this.productName}/details`], {
                    state: {
                      requestID: response.data.ILRequestID
                    }
                  });
                }
              }
            }
          }
        });
    } else {
      StaticMethods.showMessage('لطفا شماره بیمه نامه را پر کرده و سپس برروی دکمه ادامه کلیک نمایید.');
    }
  }
}
